/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo} from 'react';
import SwapDeviceEditor from './SwapDeviceEditor';

interface SwapDeviceDialogProps {
  includeSwapDevice?: boolean;
  showSCISettings?: boolean;
  includeGroupProperties?: boolean;
  disableDeviceAccountChooser?: boolean;
}

/**
 * Holds dialog functionality for swapping a device.
 */
export const SwapDeviceDialog = ({
  includeSwapDevice = false,
  includeGroupProperties = false,
  disableDeviceAccountChooser = false,
  showSCISettings = false
}: SwapDeviceDialogProps) => (
  <>
    {includeSwapDevice && (
      <SwapDeviceEditor includeGroupProperties={includeGroupProperties}
        disableAccountChooser={disableDeviceAccountChooser}
        includeSwapDevice={includeSwapDevice}
        showSCISettings={showSCISettings} />
    )}
  </>
);

export default memo(SwapDeviceDialog);
